module.exports = __webpack_public_path__ + "static/img/product-part2.151b887.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/product-part2.png
// module id = tQ6h
// module chunks = 1